import { ChevronDown } from './icons'

interface SidebarSectionHeaderProps {
    label: string
    /** When provided, the header becomes clickable and shows a hover-reveal chevron
     * that collapses/expands everything under this section (Numeo Spot / Numeo One
     * TMS / Organization). Omitted for the flat layout's per-group headers, which
     * label a single group rather than a collapsible bucket of several. */
    collapsed?: boolean
    onToggle?: () => void
}

/**
 * Tiny uppercase label rendered between sections (16px top / 4px bottom / 8px
 * horizontal padding).
 */
export const SidebarSectionHeader = ({ label, collapsed, onToggle }: SidebarSectionHeaderProps) => {
    if (!onToggle) {
        return <div className="shrink-0 px-2 pb-1 pt-4 text-[11px] font-semibold uppercase tracking-wider text-foreground-muted">{label}</div>
    }
    return (
        <button
            type="button"
            onClick={onToggle}
            aria-expanded={!collapsed}
            className={[
                'group mt-3 flex w-full shrink-0 items-center justify-between rounded-lg px-2 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-foreground-muted transition-colors hover:bg-default',
                collapsed ? 'bg-default' : '',
            ].join(' ')}
        >
            <span>{label}</span>
            <span
                className={`flex shrink-0 items-center transition-[opacity,transform] duration-150 ${collapsed ? 'opacity-100 -rotate-90' : 'opacity-0 group-hover:opacity-100'}`}
            >
                <ChevronDown size={12} />
            </span>
        </button>
    )
}
